
mutation claimAirdropSignup {
    claimAirdropSignup
}
